import axios from 'axios';

export const RevisionRequestsApi = {
  getRequests: filter => axios.get(
    `/api/self/paging/request_form?filter=${JSON.stringify(filter)}`
  )
};